import { render, staticRenderFns } from "./ActualCard.vue?vue&type=template&id=764d7896&"
import script from "./ActualCard.vue?vue&type=script&lang=js&"
export * from "./ActualCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports